/*
 * Dynamically loads the GA4 gtag.js script.
 */
import { resolveReportablePageUrl } from '@/utilities/resolveReportablePageUrl'
import { BW_GA_EVENT } from '../../../constants'

function isGAScriptSrcPresent(): boolean {
  return !!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')
}

function loadGAScript() {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = 'https://www.googletagmanager.com/gtag/js'
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag =
    window.gtag ||
    function () {
      /*
       * `arguments` is a built-in object in JavaScript that contains
       * all the arguments passed to a function
       * we cannot use ...args here, so we left as ES5
       * https://stackoverflow.com/a/49046840
       */
      window.dataLayer?.push(arguments)
    }
  window.gtag('js', new Date())
}

export function initGAListener() {
  if (!isGAScriptSrcPresent() && !window.gtag) {
    loadGAScript()
  }

  /*
   * Platforms that run our snippet inside their own cross-origin container
   * (Wix) leave gtag reading the container's address rather than the studio's
   * site. Correct it before any event is forwarded, so every hit carries it.
   * Returns null everywhere else, leaving the document's own address alone.
   */
  const reportablePageUrl = resolveReportablePageUrl()
  if (reportablePageUrl && window.gtag) {
    window.gtag('set', { page_location: reportablePageUrl })
  }

  window.addEventListener('message', (event) => {
    if (event.data?.type === BW_GA_EVENT) {
      const payload = event.data.payload

      if (window.gtag)
        // Forward the event to the parent Google Analytics
        window.gtag(...payload)
    }
  })
}
